<div class="cb-margin">
    <mat-card class="cb-margin-bottom flex-col">
        <mat-card-content>
            <form #form="ngForm">
                <div class="start-center flex-row flex">
                    <mat-icon>search</mat-icon>
                    <cb-input type="text"
                              label="Search"
                              [(ngModel)]="searchFilters.data.query"
                              (ngModelChange)="searchFiltersChanged$.next($event)"
                              name="search"
                              class="cb-margin-left cb-margin-right-2x flex">
                    </cb-input>
                    @if (qsTeamPermissions.canSeeAll()) {
                        <cb-select label="Assigned To"
                                   name="userId"
                                   [(ngModel)]="searchFilters.data.userId"
                                   [options]="teamUsersOptions$ | async"
                                   class="cb-margin-right-2x">
                        </cb-select>
                    }
                    <cb-select-list label="Status"
                                    name="statusId"
                                    class="cb-margin-right-2x flex"
                                    [allOptions]="changeStatuses$ | async"
                                    [multiple]="true"
                                    [(value)]="searchFilters.data.statusId">
                    </cb-select-list>
                    <cb-select label="Order"
                               name="resultOrders"
                               [(ngModel)]="searchFilters.data.order"
                               [options]="resultOrders$ | async"
                               class="cb-margin-right-2x">
                    </cb-select>
                    <cb-select class="cb-margin-right"
                               label="Direction"
                               [(ngModel)]="searchFilters.data.direction"
                               name="direction"
                               [options]="resultDirections$ | async">
                    </cb-select>
                </div>
            </form>
            @if (searchFiltersLoaded && searchEnabled) {
                <cb-table
                    class="cb-margin-top flex"
                    label="Changes"
                    maxHeightOffset="280"
                    [infiniteScrollEnabled]="infiniteScrollEnabled"
                    [fetch]="fetchResults()"
                    [loaded]="loaded"
                    [queryUpdated]="searchFiltersChanged$"
                    [(results)]="results"
                    [(currentPage)]="currentPage">
                    <thead cbTableHead>
                    <tr>
                        <td>Job #</td>
                        <td>Change #</td>
                        <td>Lot #</td>
                        <td>Project</td>
                        <td>Address</td>
                        <td>Client Account Name</td>
                        <td>Revision</td>
                        <td>Created</td>
                        <td>Due</td>
                        <td>Assigned To</td>
                        <td>Status</td>
                        <td></td>
                    </tr>
                    </thead>
                    <tbody cbTableBody>
                        @for (changerecord of results; track changerecord) {
                            <tr>
                                <cb-td-text [value]="changerecord.jobNumber"></cb-td-text>
                                <cb-td-text [value]="changerecord.changeNumber"></cb-td-text>
                                <cb-td-text [value]="changerecord.lotNumber"></cb-td-text>
                                <cb-td-text [value]="changerecord.projectName"></cb-td-text>
                                <cb-td-text [value]="getStreetAddress(changerecord)"></cb-td-text>
                                <cb-td-text [value]="changerecord.clientAccountName"></cb-td-text>
                                <cb-td-text [value]="changerecord.revision"></cb-td-text>
                                <cb-td-date [value]="changerecord.createDate"></cb-td-date>
                                <cb-td-date [value]="changerecord.dueBy"></cb-td-date>
                                <cb-td-text [value]="changerecord.assignedToUser"></cb-td-text>
                                <cb-td-text [value]="changerecord.changeStatus"></cb-td-text>
                                <td cbTableShrinkCol
                                    cbTableStickyCol="end">
                                    <cb-button (clicked)="viewLotChanges(changerecord.lotId)"
                                               icon="pageview">
                                    </cb-button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </cb-table>
            }
        </mat-card-content>
    </mat-card>
</div>
